export default __webpack_public_path__ + "8f2686f9b377f02ad983826743fac464.png";